import qs from 'qs';

export function getRequest (name,src='') {
  const url = src || window.location.href;
  const [, search] = url.split('?');
  return search ? qs.parse(search)[name] || '' : '';
}

export function formulaTypeName(formulaType){
  let str = ''
  if(formulaType === 1) str = '配合饲料'
  if(formulaType === 2) str = '混合日粮'
  if(formulaType === 3) str = 'TMR'
  if(formulaType === 4) str = '定制料'
  return str
}

export function checkEmpty(value,name){
  // 判断为空格，或者全部为空格的情况
  // let name = value.split('  ')
  let nameArr = value.split(' ')
  let flag = 0
  let msg = ''
  nameArr && nameArr.forEach(e => {
    if(!e){
      flag++
    }
  })
  if(value === ' ' || flag === nameArr.length){
    msg = `${name}不能为空格`
    return msg
  }
  // 判断首位有空格的情况
  if(value.indexOf(' ') === 0){
    msg = `${name}首位不能为空格`
    return msg
  }
  // 判断末位有空格的情况
  if(value){
    let valueArr = Array.from(value)
    if(!valueArr[valueArr.length - 1] || valueArr[valueArr.length - 1] === ' '){
      msg = `${name}末位不能为空格`
      return msg
    }
  }

  // 判断为缩进的情况
  let nameArr2 = value.split('	')
  let flag2 = 0
  nameArr2 && nameArr2.forEach(e => {
    if(!e){
      flag2++
    }
  })
  // 判断全为缩进的情况
  if(value === '	' || flag2 === nameArr2.length){
    msg = `${name}不能为缩进`
    return msg
  }
  // 判断首位有缩进的情况
  if(value.indexOf('	') === 0){
    msg = `${name}首位不能为缩进`
    return msg
  }
  // 判断末位有缩进的情况
  if(value){
    let valueArr = Array.from(value)
    if(!valueArr[valueArr.length - 1] || valueArr[valueArr.length - 1] === '	'){
      msg = `${name}末位不能为缩进`
      return msg
    }
  }
}

export function exportExcel (data, name) {
  let blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"}); // 设置文件类型excel
  let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
  // 创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
  let a = document.createElement("a");
  a.href = url;
  console.log(url)
  console.log()
  a.download = name + ".xlsx";
  a.click();
  // 释放这个临时的对象url
  window.URL.revokeObjectURL(url);
 }

// 导出
import axios from 'axios'
import { baseUrl } from '@/Utils/url.js'

export let instance = axios.create({
  timeout: 100000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    responseType: 'arraybuffer'
  },
  responseType: 'arraybuffer'
})
instance.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem('accessToken')
    if (token) config.headers.common['iot-Auth'] = 'bearer ' + token
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// if (process.env.NODE_ENV === 'production') {
  instance.defaults.baseURL = baseUrl
// }
export const fileDownload = (url, data) =>
  instance.get(url, { params: data }).then(response => {
   const f = response.headers['Content-Disposition'] || response.headers['content-disposition']
   const type = response.headers['Content-Type'] || response.headers['content-type']
   const fileName = f.match(/filename=(.*)/)[1]
   // 将二进制流转为blob
   const blob = new Blob([response.data], {
     type
   })
   if (typeof window.navigator.msSaveBlob !== 'undefined') {
     // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
     window.navigator.msSaveBlob(blob, decodeURI(fileName))
   } else {
     // 创建新的URL并指向File对象或者Blob对象的地址
     const blobURL = window.URL.createObjectURL(blob)
     // 创建a标签，用于跳转至下载链接
     const tempLink = document.createElement('a')
     tempLink.style.display = 'none'
     tempLink.href = blobURL
     tempLink.setAttribute('download', decodeURI(fileName))
     // 兼容：某些浏览器不支持HTML5的download属性
     if (typeof tempLink.download === 'undefined') {
       tempLink.setAttribute('target', '_blank')
     }
     // 挂载a标签
     document.body.appendChild(tempLink)
     tempLink.click()
     document.body.removeChild(tempLink)
     // 释放blob URL地址
     window.URL.revokeObjectURL(blobURL)
   }
 })

//  监控进度
export const progressDownLoad = ({url,data})=>{
  instance({method:'get',url,  params: data ,onDownloadProgress:(evt) => {
    console.log(evt)
  }}).then(response => {
    const f = response.headers['Content-Disposition'] || response.headers['content-disposition']
    const type = response.headers['Content-Type'] || response.headers['content-type']
    const fileName = f.match(/filename=(.*)/)[1]
    // 将二进制流转为blob
    const blob = new Blob([response.data], {
      type
    })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
      window.navigator.msSaveBlob(blob, decodeURI(fileName))
    } else {
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', decodeURI(fileName))
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank')
      }
      // 挂载a标签
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL)
    }
  })
}